import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  showToastify: ['data']
});

const INITIAL_STATE: any = { show: false };

const showToastify = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.SHOW_TOASTIFY as any]: showToastify
});